import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ActionButton from '@app/components/ui/buttons/ActionButton'
import BackLink from '@app/components/ui/buttons/BackLink'
import classnames from 'classnames'
import { h } from '@app/helpers/translationHelper'
import { Student } from '@app/models/users'

class Start extends Component {
  constructor(props) {
    super(props)
    this.handleStart = this.handleStart.bind(this)
  }

  handleStart(_) {
    const { boundStudentActions } = this.props
    boundStudentActions.participate({ tour: 'main' })
  }

  render() {
    const { student, participate: { starting } } = this.props
    const classes = classnames('page', 'confirm-start-page')

    return (
      <div className="page">
        <span className="hide-mobile">
          <BackLink to="/students/tours/main/intro" className="back-link__abs" />
        </span>
        <div className="plate">
          <span className="mobile-only">
            <BackLink to="/students/tours/main/intro" className="back-link" />
          </span>
          <h1 className="plate-heading">
            { I18n.t('students.proceed_olymp.note') }
          </h1>

          <div className="confirm-start-page__text mb-gutter-l">
            <p className="plate-content text-left f--default"
                 dangerouslySetInnerHTML={ h('students.proceed_olymp.timer_starts_html') }
            />
            <p className="plate-content text-left f--default"
                 dangerouslySetInnerHTML={ h('students.proceed_olymp.time_to_solve_it') }
            />
            <p className="plate-content text-left f--default"
                 dangerouslySetInnerHTML={ h('students.proceed_olymp.no_break') }
            />
          </div>
          <div className="confirm-start-page__content">
            <div className="confirm-start-page__inner">
              <div className="olymp-timer mb-4">
                <div className="olymp-timer__item"> 6 </div>
                <div className="olymp-timer__item"> 0 </div>
                <div className="olymp-timer__colon"> : </div>
                <div className="olymp-timer__item"> 0 </div>
                <div className="olymp-timer__item"> 0 </div>
              </div>

              <div className="w-flex-layout w-flex-layout--columns">
                <ActionButton
                  className="btn btn--light-blue f--upper"
                  onClick={this.handleStart}
                  disabled={starting}
                  loading={starting}>
                  { I18n.t('students.proceed_olymp.start') }
                </ActionButton>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

Start.propTypes = {
  boundStudentActions: PropTypes.object.isRequired,
  student: PropTypes.instanceOf(Student).isRequired,
  participate: PropTypes.object.isRequired
}

export default Start
